// extracted by mini-css-extract-plugin
export const mainSection = "bookhead-module--mainSection--1SkfF";
export const contentWrap = "bookhead-module--contentWrap--1DYmc";
export const content = "bookhead-module--content--3QXUP";
export const button4 = "bookhead-module--button4--3i9Tz";
export const btn4 = "bookhead-module--btn4--1FYIB";
export const back = "bookhead-module--back--2XacD";